import axios from 'axios';
import dayjs from 'dayjs';
import { uniqWith } from 'lodash';

const WP_BASE = 'https://pacificrimsafety.ca';
const WC_SLOTS_URL = `${WP_BASE}/wp-json/wc-appointments/v1/slots`;

export const splitCourseAndLocation = (productName) => {
  const parts = String(productName || '').split(/\s*[-–]\s*/);
  return {
    course: (parts[0] || productName || '').trim(),
    location: (parts[1] || '').trim(),
  };
};

export const parseSlotDate = (dateStr) => {
  if (!dateStr) return dayjs(null);
  return dayjs(dateStr);
};

export const buildSlotBookingUrl = (slot) => {
  const dateStr = String(slot.date || '').substring(0, 10);
  const timeStr = String(slot.date || '').substring(11, 16) || '08:30';
  return `${WP_BASE}/product/${slot.product_id}?date=${dateStr}&time=${timeStr}`;
};

export const mapSlotRecord = (record) => {
  const { course, location } = splitCourseAndLocation(record.product_name);
  const calendarDay = String(record.date || '').substring(0, 10);

  return {
    product_id: record.product_id,
    product_name: record.product_name,
    course,
    location,
    date: record.date,
    calendarDay,
    booking_url: buildSlotBookingUrl(record),
  };
};

export const dedupeSlots = (records) =>
  uniqWith(records, (a, b) =>
    a.product_id === b.product_id && dayjs(a.date).isSame(dayjs(b.date), 'day')
  );

export const fetchWooAppointmentSlots = async (maxDate) => {
  const { data } = await axios.get(WC_SLOTS_URL, {
    params: { max_date: maxDate },
    timeout: 60000,
  });

  const records = Array.isArray(data?.records) ? data.records : [];
  return dedupeSlots(records).map(mapSlotRecord);
};
